export const IMAGE_MAX_FILE_SIZE_KB = 300;
export const IMAGE_MAX_FILE_SIZE_BYTES = IMAGE_MAX_FILE_SIZE_KB * 1024;
export const IMAGE_RECOMMEND_SIZE_PX = 56;

export const IMAGE_VALID_NAME_REGEX = /^.+\.(png|jpe?g)$/i;
export const IMAGE_VALID_TYPE_REGEX = /^image\/(jpeg|png)$/;
